export default "__VITE_ASSET__8f689944__"